import {createSlice, isAnyOf} from '@reduxjs/toolkit';

import {Group} from '~shared/models';

import {makeComGroupIdentityKey} from '~ui/utils';

import {getPageAcl, updatePageSettings} from '../pages/thunks';

interface GroupsState {
    entities: Record<string, Group>;
}

const initialState: GroupsState = {
    entities: {},
};

const setGroup = (state: GroupsState, group: Group) => {
    const key = makeComGroupIdentityKey(group.identity);

    const entity = state.entities[key];

    if (!entity) {
        state.entities[key] = group;
    } else {
        Object.assign(entity, group);
    }
};

export const {actions, reducer} = createSlice({
    name: 'groups',
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder.addMatcher(
            isAnyOf(getPageAcl.fulfilled, updatePageSettings.fulfilled),
            (state, {payload}) => {
                payload.acl?.groups?.forEach((group) => {
                    if (group.type !== 'department') {
                        setGroup(state, group);
                    }
                });
            },
        ),
});
